import React from 'react';

const DOTS = ['var(--c-accent)', 'var(--c-warm)', 'var(--c-accent-400)'];

const WelcomeScreen = ({ onBegin }) => (
  <div
    style={{
      minHeight: '100svh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: 'clamp(24px, 6vw, 60px)',
      gap: 22,
    }}
  >
    <div style={{ display: 'flex', gap: 10, animation: 'ibgFadeUp 0.7s ease both' }}>
      {DOTS.map((c, i) => (
        <div
          key={i}
          style={{
            width: 15,
            height: 15,
            borderRadius: '50%',
            background: `linear-gradient(180deg, ${c} 0 50%, var(--c-n-100) 50%)`,
            boxShadow: '0 2px 5px rgba(90, 60, 40, 0.25)',
          }}
        />
      ))}
    </div>
    <div
      style={{
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.28em',
        color: 'var(--c-accent-700)',
        animation: 'ibgFadeUp 0.7s 0.08s ease both',
      }}
    >
      KOREADY · LANGUAGE EXCHANGE
    </div>
    <h1
      style={{
        margin: 0,
        fontFamily: 'var(--f-heading)',
        fontWeight: 400,
        fontSize: 'clamp(40px, 7.5vw, 60px)',
        lineHeight: 1.08,
        letterSpacing: '0.005em',
        animation: 'ibgFadeUp 0.7s 0.16s ease both',
      }}
    >
      So glad you're here.
    </h1>
    <p
      style={{
        margin: 0,
        maxWidth: 460,
        fontSize: 'clamp(15px, 2.2vw, 17px)',
        lineHeight: 1.65,
        color: 'var(--c-n-700)',
        textWrap: 'pretty',
        animation: 'ibgFadeUp 0.7s 0.24s ease both',
      }}
    >
      Still a little shy? Perfectly fine. Tonight we share what's been on our
      minds — slow, cozy, one question at a time. Who knows what might begin
      here.
    </p>
    <button
      type='button'
      onClick={onBegin}
      className='ibg-btn-primary'
      style={{
        marginTop: 10,
        fontSize: 15,
        padding: '16px 36px',
        animation: 'ibgFadeUp 0.7s 0.32s ease both',
      }}
    >
      Let's begin
    </button>
  </div>
);

export default WelcomeScreen;
